var App = App || {};

App.CmpMediaCarousel = (function ($) {
    'use strict';

    function Init(widget) {

        const carousel = widget.find(".splide");
        if (!carousel.length)
            return false;

        Carousel(carousel);
    }

    function Carousel(carousel, options) {

        const status = carousel.find(".splide__status");
        const splide = new Splide(carousel[0], {
            type: "loop",
            focus: "center",
            pagination: false,
            autoWidth: true
        });

        splide.on('mounted', function () {
            status.children(".current").text("1");
            status.children(".divider").text("/");
            status.children(".total").text(splide.length);

            App.CmpMultiMedia.TranscriptAlignment(carousel);
        });
        
        splide.on('resize', function () {
            App.CmpMultiMedia.TranscriptAlignment(carousel);
        });

        splide.on('move', function (newIndex, prevIndex) {

            status.children(".current").text(newIndex + 1);

            const multiMedia = carousel.find(".cmp--multiMedia__video iframe").parents(".cmp--multiMedia__video");
            multiMedia.each(function () {
                App.CmpMultiMedia.Stop($(this));
            });
        });

        splide.mount({});

    }

    return {
        Init: Init
    };

})(jQuery);